import { CommonModule } from '@angular/common';
import { Component, ComponentFactoryResolver, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { CommondataService } from '../source/services/games/commondata.service';
import { GamesService } from '../source/services/games/games.service';
import { LoginState } from '../source/appstates/loginstates/loginState';
import { PlayerService } from '../source/services/player/player.service';
import { SlotsService } from '../source/services/slotsservice/slots.service';
import { Store } from '@ngrx/store';
import * as appState from '../../app/source/appstates/appState'
import { Subscription } from 'rxjs';
import { QuickloginComponent } from '../media/quicklogin/quicklogin.component';
import * as loginActions from '../../app/source/appstates/loginstates/loginActions'
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-all-gameprovider',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, FormsModule],
  templateUrl: './all-gameprovider.component.html',
  styleUrl: './all-gameprovider.component.css'
})
export class AllGameproviderComponent {
  private closeSub!: Subscription;
  allGamesTotal: any;
  slotsGames: any;
  LiveallGames: any;
  IndiallGames: any;
  IndicasinoGames: any;
  liveCasinogames: any;
  aviator: any;
  noGameFound: boolean = false;
  searchProvider: any;
  playerLoggedIn: boolean = false;
  tokenIndicasino: any;
  platipusGameUrl: any;
  arrowEdgeGameUrl: any;
  rocketManGameUrl: any;
  token1: any;
  operatorId: any;
  serverId: any;
  homeUrl: any;
  currency: any;
  private storeSub!: Subscription;
  @ViewChild('alertHost', { read: ViewContainerRef }) alertHost!: ViewContainerRef;
  token: any;
  loadedImages: { [key: string]: boolean } = {};
  selectedCategory: any = 'Lobby'
  searchText: any;
  red2gms1: any[] = [];
  inpUserResp: any;
  jsonData: any[] = [];
  saveAllgames: any[] = [];
  currentIndex: any;
  filterGamesName: any;
  arrowedgmname: any;
  men5Url: any;
  keyname: any;
  tokendata: any;
  slotsdata: any;
  gamelunchurl: any;
  name: any;
  gameName: any;
  tomhornGameUrl: any;
  @ViewChild('searchInput') searchInputRef: ElementRef | undefined;
  gamenameevo: any;
  pragmaticPlayGames: any;
  activeProviders: any;
  filteredGamesList: any[] = [];
  constructor(private router: Router,private playerService:PlayerService, private componentFactoryResolver: ComponentFactoryResolver, public sanitizer: DomSanitizer, private store: Store<appState.AppState>, private comman: CommondataService, private slotsService: SlotsService, private gamesService: GamesService) {

  }
  ngOnInit() {

    this.slotsService.getproviderList().subscribe((data: any) => {
      this.activeProviders = new Set(data.filter((p: any) => p.status === true && p.name !== "All Providers")
        .map((p: any) => p.name.toLowerCase()))
          this.loadJsonData();
    })


    this.storeSub = this.store.select("loginState").subscribe((loginState: LoginState) => {
      if (loginState.playerLoggedIn) {
        if (loginState.playerLoggedIn.loggedIn) {
          this.playerLoggedIn = loginState.playerLoggedIn.loggedIn;
          // this.slotsService.gamelunallproviders().subscribe((response: any) => {
          //   this.allvivoprovidersurl(response)
          // })
          let games = sessionStorage.getItem('wsessionBD')
          if (games) {
            this.slotsService.indiecasino(games).subscribe((data: any) => {
              this.tokenIndicasino = data;
            })
          }
        } else {
          this.playerLoggedIn = false;
        }
      }
    })
    this.gamecloseapi()
  }
  focusSearchInput() {
    setTimeout(() => {
      this.searchInputRef?.nativeElement?.focus();
    });
  }
  allvivoprovidersurl(data: any) {
    this.platipusGameUrl = data.platipusGameUrl
    this.arrowEdgeGameUrl = data.arrowEdgeGameUrl
    this.rocketManGameUrl = data.rocketManGameUrl
    this.tomhornGameUrl = data.tomhornGameUrl
    this.token1 = data.token
    this.operatorId = data.operatorId
    this.serverId = data.serverId
    this.homeUrl = data.homeUrl
    this.currency = data.currency
  }
  selectCategory(category: any) {
    this.selectedCategory = category;

    if (category === 'Sports') {
      this.router.navigate(['/sports']);
      return;
    }
    this.searchProvider = '';
    const allCategoryGames = this.getGamesByCategory(category);
    this.currentIndex = 22;
    this.red2gms1 = allCategoryGames.slice(0, this.currentIndex);
  }

  getGamesByCategory(category: string) {
    switch (category) {
      case 'Slots':
        return this.filterGamesName.filter(
          (game: any) =>
            game.gameType !== "CASINO" &&
            game.provider !== 'Evolution' && game.provider !== 'Ezugi'
        );

      case 'Live Casino':
        return this.LiveallGames;

      case 'Originals':
        return this.IndiallGames;

      case 'Aviator':
        return this.aviator;

      case 'Lobby': // All games including IndiCasino and Livecasino
        return this.filterGamesName;

      default:
        return this.filterGamesName;
    }
  }

  
  gvproviderapi(data: any) {
    if (!this.playerLoggedIn) {
      return this.showPopUp('LOGIN');
    }
    let body = {
      "gameId": data.id,
      "provider": data.provider,
      "language": "en"
    }
    this.slotsService.gvproviderapi(body).subscribe((data: any) => {
      if (data) {
        sessionStorage.setItem('closeGameSession', data.token);
        if (data.url) {
          this.comman.setGameUrl(data.url);
          this.gamelunchUrl(data.url, data);
        }
      }
    })
  }



  flattenGamesFromJsonData(data: any): any[] {
    const games: any = [];
    for (const key in data) {
      if (Array.isArray(data[key])) {
        games.push(...data[key].map((g: any) => ({ ...g, providerKey: key })));
      }
    }
    return games;
  }

  filterGamesProvider(): void {
    const sourceGames = this.getGamesByCategory(this.selectedCategory);
    const searchTerm = this.searchProvider?.toLowerCase() || '';
  
    if (searchTerm) {
      this.filteredGamesList = sourceGames.filter((game: any) =>
        game?.gameName?.toLowerCase().includes(searchTerm) ||
        game?.displayName?.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredGamesList = [...sourceGames];
    }
  
    this.currentIndex = 22;
    this.red2gms1 = this.filteredGamesList.slice(0, this.currentIndex);
  
    this.noGameFound = this.filteredGamesList.length === 0;
  }

  evogamesin(data: any, gameName: any) {
    this.gamenameevo = data
    if (this.playerLoggedIn == true) {
      let wesessioid = sessionStorage.getItem('wsessionBD')
      this.slotsService.getEzugi(wesessioid).subscribe((data: any) => {
        let evourl = `${data.EZUGI_GAME_URL}token=${data.EZUGI_TOKEN}&operatorId=${data.EVO_STANDARD_OPERATOR_ID}&[language=en&clientType=html5&openTable=${this.gamenameevo}&homeUrl=https://zupwinbd.com/home]`
        if (evourl) {
          this.comman.setGameUrl(evourl);
          this.router.navigate(['/GameLaunch', { gameName }]);
        } else if (evourl == "") {
          this.router.navigate(['/'])
        }
      })
    } else {
      this.showPopUp('LOGIN')
    }
  }
  enterGame(id: any, gameName: any) {
    if (this.playerLoggedIn == true) {
      let sendToIndie = "gameId=" + id + '\&playerToken=' + this.tokenIndicasino["token"] + '\&site=' + environment.skinId;
      var indieUrl = this.tokenIndicasino["url"] + "/"
      var urlLunch = indieUrl + gameName.displayName + '?' + sendToIndie;
      if (urlLunch) {
        this.gamelunchUrl(urlLunch, { gameName });

      } else if (urlLunch == "") {
        this.router.navigate(['/'])
      }
    } else {
      this.showPopUp('LOGIN')
    }
  }
  showPopUp(value: string) {
    this.store.dispatch(new loginActions.ResetState());
    const alertCmpFactory = this.componentFactoryResolver.resolveComponentFactory(
      QuickloginComponent
    );
    const hostViewContainerRef = this.alertHost;
    hostViewContainerRef.clear();
    const componentRef = hostViewContainerRef.createComponent(alertCmpFactory);
    componentRef.instance.formState = value;
    this.closeSub = componentRef.instance.close.subscribe(() => {
      this.closeSub.unsubscribe();
      hostViewContainerRef.clear();
    });
  };
  ngOnDestroy() {
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
    if (this.closeSub) {
      this.closeSub.unsubscribe();
    }
    this.gamesService.changeStatus(true);
  }
  onImageLoad(image: any) {
    this.loadedImages[image] = true;
    this.loadedImages[image.gameName] = true;
  }
  onJDBGames(gType: any, mType: any, gameName: any) {
    if (this.playerLoggedIn) {
      this.slotsService.jdbLaunch(gType, mType).subscribe(((data: any) => {
        let gameUrl = data.path;
        if (gameUrl) {
          this.gamelunchUrl(gameUrl, gameName);

        } else if (gameUrl == "") {
          this.router.navigate(['/'])
        }
      }))

    } else {
      this.showPopUp('LOGIN');
    }
  }
  filterGames() {
    const searchTerm = (this.searchText && typeof this.searchText === 'string') ? this.searchText.toLowerCase() : '';
    if (this.red2gms1 && this.red2gms1.length > 0) {
      this.red2gms1 = this.red2gms1.filter((item: any) => {
        const gameName = (item.gameName && typeof item.gameName === 'string') ? item.gameName.toLowerCase() : '';
        return gameName.includes(searchTerm);
      });
      if (this.red2gms1.length === 0 || searchTerm === '') {
        this.inpUserResp = "";
      } else {
        this.inpUserResp = 'User not found';
      }
    } else {
      this.red2gms1 = [];
      this.inpUserResp = 'User not found';
    }
  }
  loadJsonData(): void {
    this.gamesService.games$.subscribe((data: any) => {
      if (data) {
        this.jsonData = data; 
        this.LiveallGames = data.filter((game:any)=> game.provider == 'Evolution' ||  game.provider == 'Ezugi');

        this.IndiallGames = data.filter((game:any)=> game.gameType == 'CASINO')
        this.liveCasinogames = this.LiveallGames;
        this.IndicasinoGames = this.IndiallGames;
        this.flattenAllGames(); // Flatten everything including live and indi
      }
    });
    this.focusSearchInput();
  }
  torrospinsList(gameId,Provider){
    if (this.playerLoggedIn) {
      let body = {
        "gameId": gameId,
        "provider": Provider
      }
      this.slotsService.getTorrospinGameLaunch(body).subscribe((resData:any)=>{
        console.log(resData)
        console.log(resData.url)
        if(resData && resData.url && resData.success){
          localStorage.setItem("tokenTorro",resData.token)
          this.gamelunchUrl(resData.url, gameId)   
       
        }
      })
    } else {
      this.showPopUp("LOGIN")
    }
  }

  flattenAllGames(): void {
    let games: any = [];
    const filteredGamesJsonData = Object.keys(this.jsonData)
      .filter(providerKay => this.activeProviders.has(providerKay.toLowerCase()))
      .reduce((acc: any, providerKay) => {
        acc[providerKay] = this.jsonData[providerKay];
        return acc;
      }, {});

    games = Object.values(filteredGamesJsonData).flat();

    this.saveAllgames =this.jsonData
    this.filterGamesName = [...this.saveAllgames];
    this.currentIndex = 24;
    this.red2gms1 = this.filterGamesName.slice(0, this.currentIndex);
  }

  nucluesGames(data: any, gameName: any) {
    if (this.playerLoggedIn) {
      let url = "https://bscpl1env01.kasoom.com/FlashRunGame/RunGenericGame.aspx?tableguid=1557B2530867491492F047100436A36F" + "&GameID=" + data + "&token=" + this.token1 + "&operatorid=" + this.operatorId
      this.gamelunchUrl(url, gameName);
    } else {
      this.showPopUp('LOGIN')

    }
  }
  tonhornGame(data: any, gameName: any) {
    if (this.playerLoggedIn) {
      let url = this.tomhornGameUrl + "GameID=" + data + "&Token=" + this.token1 + "&lang=EN&OperatorID=" + this.operatorId;
      this.gamelunchUrl(url, gameName);
    } else {
      this.showPopUp('LOGIN')

    }
  }
    aviatrix(game: any) {
    if (this.playerLoggedIn) {
      let body = {
        "gameId": game.gameId, "provider": game.provider
      }
      this.slotsService.aviatrix(body).subscribe((res: any) => {
        if(res.success){
          this.gamelunchUrl(res.url, game);
        }else{
          console.log(res.message)
        }
        console.log(res)
      })
    } else {
      this.showPopUp('LOGIN')

    }
  }
  arrorsEdge12(data: any, gameName: any) {
    if (this.playerLoggedIn) {
      this.arrowedgmname = data
      let url = this.arrowEdgeGameUrl + "tableguid=JJMCHE34297J22JKDX22&token=" + this.token1 + "&OperatorId=" + this.operatorId + "&homeUrl=" + this.homeUrl + "&language=en&gameID=" + this.arrowedgmname + "&cashierUrl=&gameMode=REAL&currency=" + sessionStorage.getItem('wallet')
      this.gamelunchUrl(url, gameName);
    } else {
      this.showPopUp('LOGIN')

    }
  }
  smengm(data: any, gameName: any) {
    if (this.playerLoggedIn) {
      let url1 = this.men5Url + "tableguid=1DFE4EC22BF545ECB37EAF2D07BE9515" + "&OperatorId=" + this.operatorId + "&token=" + this.token1 + "&gameid=" + data + "&client=778877"
      this.gamelunchUrl(url1, gameName);

    } else {
      this.showPopUp('LOGIN')
    }

  }
  platipus12(data: any, gameName: any) {
    if (this.playerLoggedIn) {
      let url = this.platipusGameUrl + "token=" + this.token1 + "&operatorID=" + this.operatorId + "&room=125" + "&gameconfig=" + data
      this.gamelunchUrl(url, gameName);

    } else {
      this.showPopUp('LOGIN')
    }
  }
  slotsreal(data: any, gameName: any) {
    if (this.playerLoggedIn) {
      this.keyname = data;
      if (this.tokendata == null) {
        let profile = sessionStorage.getItem('wsessionBD');
        this.slotsService.httpClient(profile, data).subscribe(data => {
          this.slotsdata = data.URL;
          this.tokendata = this.slotsdata.TOKEN;
          if (this.slotsdata) {
            this.gamelunchurl = this.slotsdata.HABANERO_GAMING_URL + 'brandid=' + this.slotsdata.BRAND_ID + '&keyname=' + this.keyname + '&token=' + this.slotsdata.TOKEN + '&mode=real&locale=en';
            this.gamelunchUrl(this.slotsdata, gameName);

          }
        },
        );
      } else if (this.tokendata != null) {
        this.gamelunchurl = this.slotsdata.HABANERO_GAMING_URL + 'brandid=' + this.slotsdata.BRAND_ID + '&keyname=' + this.keyname + '&token=' + this.slotsdata.TOKEN + '&mode=real&locale=en';
        this.gamelunchUrl(this.gamelunchurl, gameName);

      }
    } else if (this.playerLoggedIn == false) {
      this.showPopUp('LOGIN')

    }
  }
  evolutiongms(name: any, gameName: any) {
    this.name = name
    if (this.playerLoggedIn == true) {
      let wsessionid = sessionStorage.getItem('wsessionBD')
      this.slotsService.getEzugi(wsessionid).subscribe(data => {
        let evourl: any = `${data.EZUGI_GAME_URL}platformId=0&operatorId=10193029&token=${data.EZUGI_TOKEN}&openTable=${this.name}`
        this.gamelunchUrl(evourl, gameName);
      })
    } else {
      this.showPopUp('LOGIN')
    }

  }
  kagamingmethod(game: any) {
    if (this.playerLoggedIn) {
      let body = {
        "gameId": game.gameId, "provider": game.provider
      }
      this.playerService.Kagaming(body).subscribe((res: any) => {
        if(res.success){
          this.gamelunchUrl(res.url, game);
        }else{
          console.log(res.message)
        }
        console.log(res)
      })
    } else {
      this.showPopUp('LOGIN')

    }
  }
  kingmidasmethod(game: any) {
    if (this.playerLoggedIn) {
      let body = {
        "gameId": game.gameId, "provider": game.provider
      }
      this.slotsService.kingmidaslaunch(body).subscribe((res: any) => {
        if(res.success){
          this.gamelunchUrl(res.url, game);
        }else{
          console.log(res.message)
        }
        console.log(res)
      })
    } else {
      this.showPopUp('LOGIN')

    }
  }
  liveDealer(gname: any, gameName1: any) {
    this.gameName = gname;
    if (this.playerLoggedIn == true) {
      let wsessionId = sessionStorage.getItem('wsessionBD')
      this.slotsService.liveDealerServiceData(wsessionId).subscribe((liveDealerdata: any) => {
        let ezugiLunch = liveDealerdata.EZUGI_GAME_URL + 'token=' + liveDealerdata.EZUGI_TOKEN + '&operatorId=' + liveDealerdata.EZUGI_OPERATOR_ID + '&clientType=html5&language=en&selectGame=' + this.gameName;
        if (ezugiLunch) {
          this.gamelunchUrl(ezugiLunch, gameName1);
        }
      });
    } else if (this.playerLoggedIn == false) {
      this.showPopUp('LOGIN')

    }
  }

  onLaunchPragmatic(data: any, gameName: any) {
    localStorage.setItem("praggameid", data)
    console.log(data)
    let wession = sessionStorage.getItem("wsession");
    console.log(data);

    if (this.playerLoggedIn) {
      this.slotsService.getPragmaticHit(data).subscribe(data => this.pragmaticres(data, gameName))
    } else {
      this.showPopUp('LOGIN')
    }

  }
  pragmaticres(data: any, gameName: any) {
    console.log(data.gameURL)
    let url = data.gameURL
    this.gamelunchUrl(url, gameName)
    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url)

  }
  showMorebtn() {
    this.currentIndex += 22;
  
    const source = this.filteredGamesList.length
      ? this.filteredGamesList
      : this.filterGamesName;
  
    this.red2gms1 = source.slice(0, this.currentIndex);
  }
  gamelunchUrl(url: any, routePath: any) {
    this.comman.setGameUrl(url);
    this.comman.hide();
    this.router.navigate(['/GameLaunch'], {
      queryParams: {
        path: this.router.url.split("/")[1],
        provider: routePath.provider,
        name: routePath.displayName ? routePath.displayName : routePath.gameName
      }
    });

  }
  launchGame() {
    this.comman.hide();
  }

  zepllienGame(game_id: any, gameName: any) {

    if (this.playerLoggedIn == true) {
      let gameUrl: any
      if (gameName == "Zepellin") {
        gameUrl = `https://bscpl1env01.kasoom.com/FlashRunGame/RunGenericGame.aspx?tableguid=8DA5238BE58541838D128466C5A6BF58&gameid=7001&token=${this.token1}&operatorID=3006292&language=en`
      } else {
        gameUrl = this.rocketManGameUrl + "tableguid=71CCEC005BA14E01A426AA1CFC45EAE2&token=" + this.token1 + "&OperatorId=" + this.operatorId + "&language=en&cashierUrl=&homeUrl=&GameID=" + game_id + "&mode=real&bank=157"
      }

      if (gameUrl) {
        this.gamelunchUrl(gameUrl, gameName)
      } else if (gameUrl == "") {
        this.router.navigate(['/'])
      }
      this.gamesService.changeStatus(false);
    } else {
      this.showPopUp('LOGIN')
    }
  }


  clearFilter() {
    this.searchProvider = '';
    this.filteredGamesList = [];
  
    this.currentIndex = 24;
    this.red2gms1 = this.filterGamesName.slice(0, this.currentIndex);
  }
  gamecloseapi() {
    const token = localStorage.getItem('tokenTorro');
    if (!token) {
      console.log('Game already closed, skipping API call');
      return;
    }
  
    this.slotsService.gameclose().subscribe({
      next: (data:any) => {
        console.log('Game closed:', data);
        localStorage.removeItem('tokenTorro'); // ensure only once
      },
      error: (err) => console.error('Error closing game', err)
    });
    let gameSession = sessionStorage.getItem("closeGameSession") || '';
    let body = {
      "gameSession": token
    }
    this.slotsService.closeGameSession(body).subscribe({
      next: (data:any) => {
        console.log('Game closed:', data);
        localStorage.removeItem('tokenTorro'); // ensure only once
      },
      error: (err) => console.error('Error closing game', err)
    });
  }
  vivogameLaunch(game:any){
    if(this.playerLoggedIn){
      if(game.provider == 'vivogaming'){
        this.slotsService.gamelunallvivogaming().subscribe((response:any)=>{
          const launchUrl = response.VIVO_GAME_LAUNCH_URL.split("selectedGame=")[0] + `selectedGame=${game.gameId}` + response.VIVO_GAME_LAUNCH_URL.split("selectedGame=All")[1];
          this.comman.setGameUrl(launchUrl);
          this.gamelunchUrl(launchUrl, game); 
        
        })
      }else{
        this.slotsService.gamelunallproviders(game).subscribe((response:any)=>{
          this.comman.setGameUrl(response.url);
          this.gamelunchUrl(response.url, game); 
          console.log(response)
        })
    
      }

    }else{
      this.showPopUp('LOGIN');

    }
  }
}
